import r from "./_hashClear.js";
import s from "./_hashDelete.js";
import p from "./_hashGet.js";
import l from "./_hashHas.js";
import m from "./_hashSet.js";
var i = r, f = s, _ = p, v = l, y = m;
function t(h) {
  var e = -1, o = h == null ? 0 : h.length;
  for (this.clear(); ++e < o; ) {
    var a = h[e];
    this.set(a[0], a[1]);
  }
}
t.prototype.clear = i;
t.prototype.delete = f;
t.prototype.get = _;
t.prototype.has = v;
t.prototype.set = y;
var u = t;
export {
  u as default
};
//# sourceMappingURL=_Hash.js.map
